// extracted by mini-css-extract-plugin
module.exports = {"actions":"ButtonBuy-module--actions--3MT1q","help":"ButtonBuy-module--help--av5yB"};